export default class ColorUtils {

    static getColor(inner, index) {
        if (inner) {
            switch(index) {
                case 0: // light red
                    return this.rgbToHex(255, 192, 192)
                case 1: // light orange
                    return this.rgbToHex(255, 255, 192)
                case 2: // light green
                    return this.rgbToHex(192, 255, 192)
                case 3: // light cyan
                    return this.rgbToHex(192, 255, 255)
                case 4: // light violet
                    return this.rgbToHex(127, 192, 255)
                default: 
                    return this.rgbToHex(255, 255, 255)
            }
        }
        switch(index) {
            case 0: // red
                return this.rgbToHex(255, 0, 0)
            case 1: // orange
                return this.rgbToHex(255, 85, 0)
            case 2: // melon
                return this.rgbToHex(255, 170, 0)
            case 3: // yellow
                return this.rgbToHex(255, 255, 0)
            case 4: // green
                return this.rgbToHex(0, 255, 0)
            case 5: 
                return this.rgbToHex(0, 255, 127)
            case 6: // cyan
                return this.rgbToHex(0, 255, 255)
            case 7: // blue
                return this.rgbToHex(0, 0, 255)
            case 8: // violet
                return this.rgbToHex(127, 0, 255)
            case 9: // purple
                return this.rgbToHex(255, 0, 255)
            default: 
                return this.rgbToHex(0, 0, 0)
        }
    }

    static rgbToHex(r, g, b) {
        let rHex = r.toString(16)
        if (rHex.length < 2) {
            rHex = '0' + rHex 
        }
        let gHex = g.toString(16)
        if (gHex.length < 2) {
            gHex = '0' + gHex 
        }
        let bHex = b.toString(16)
        if (bHex.length < 2) {
            bHex = '0' + bHex 
        }
        return parseInt('0x' + rHex + gHex + bHex, 16)
    }
}